import { FormFieldsCustomizer } from '@kinet-open-network/client/core/forms/ui';
import { PaymentTypeDetailComponent } from '@kinet-open-network/client/payment-types/feature/detail';

export const paymentTypeFieldsCustomizer: FormFieldsCustomizer<
  PaymentTypeDetailComponent
> = (fields) => {
  return fields;
};
